import AssociatedCollections from './AssociatedCollections';

export default AssociatedCollections;
export * from './AssociatedCollections';
